export default {
	/**
	 * 改变页面title
	 * @param title 
	 */
	title(title:string){
		document.title = title;
	},
}